export default "__VITE_ASSET__BmPcVE5a__"